export const TEST_ID = 'recommendationRow';
